/** Presentation reference only: no record progress or approved workflow policy is inferred. */
export const INVESTIGATION_STAGES = [
  "Warranty Signal",
  "Problem Definition",
  "Containment",
  "Root Cause",
  "Corrective Action",
  "Engineering Change",
  "PFMEA & Control Plan",
  "Validation",
  "Effectiveness",
  "Lessons Learned / Read-Across",
  "Prevention / Closure",
] as const;

export const INVESTIGATION_VIEWS = [
  { key: "overview", label: "Overview", question: "What do we know about this issue?" },
  { key: "evidence", label: "Claims & Evidence", question: "What evidence supports this issue?" },
  { key: "workflow", label: "Workflow / 8D", question: "What are we doing to resolve it?" },
  {
    key: "effectiveness",
    label: "Effectiveness & Lessons",
    question: "Did the fix work, and where should we apply the lesson?",
  },
  {
    key: "financial",
    label: "Financial",
    question: "What is the supported financial consequence?",
  },
  {
    key: "safety",
    label: "Safety & Compliance",
    question: "What authorized assessments are available?",
  },
  {
    key: "audit",
    label: "Audit / Activity",
    question: "Which evidence and decisions can we trace?",
  },
] as const;

export type InvestigationView = (typeof INVESTIGATION_VIEWS)[number]["key"];

export const INVESTIGATION_UNAVAILABLE: Record<Exclude<InvestigationView, "overview">, string> = {
  evidence:
    "The current record read contract does not return linked claim rows, evidence attachments, or evidence lineage. A linked claim count is an aggregate, not a claim-detail projection.",
  workflow:
    "Stage state, 8D, containment, root cause, corrective actions, engineering changes, PFMEA and control-plan evidence, validation, and approval decisions are not returned by the current record contract. No progress is inferred from management status.",
  effectiveness:
    "Post-change observations, effectiveness conclusions, lessons, read-across decisions, and prevention or closure evidence are not returned. Completing an action does not prove effectiveness.",
  financial:
    "Only supplied source-reported claim cost is shown. Approved reserves, forecasts, recovery transactions, and realized savings are not returned. Source cost is not a booked accounting actual or an estimate of future exposure.",
  safety:
    "Record-scoped safety assessments, regulatory decisions, and compliance evidence are not returned. A claim pattern is not a defect determination, recall decision, or certification verdict.",
  audit:
    "Created and updated metadata are shown in the overview, but immutable decision history, actors, evidence changes, and workflow audit events are not returned. Update metadata is not an audit trail.",
};
